import { Category, useAlert } from '@drawbotics/react-drylus';
import { RouterService } from '@tokamakjs/common';
import { Controller, onDidMount, state } from '@tokamakjs/react';
import queryString from 'query-string';

import { ConfirmUserResult } from '~/api';
import { AuthGuard } from '~/guards/auth.guard';
import { AuthService } from '~/services';
import { createTranslate } from '~/utils';

import { ConfirmationView } from './confirmation.view';

const ttErrors = createTranslate('errors');
const tt = createTranslate('routes.confirmation');

@Controller({ view: ConfirmationView, guards: [AuthGuard] })
export class ConfirmationController {
  private _showAlert = useAlert().showAlert;

  @state userIsLoading = true;
  @state token?: string;
  private _restOfQueryParams: {
    [key: string]: string;
  };
  @state userIsConfirmed?: boolean;
  @state confirmationErrorOccurred?: boolean;

  @state checkingIfUserIsAlreadyConfirmed = false;

  constructor(private _router: RouterService, private readonly _authService: AuthService) {
    const restOfQueryParams: {
      [key: string]: string;
    } = {};

    for (const entry of _router.query) {
      const key = entry[0];
      const value = entry[1];

      if (key === 'token') {
        this.token = value;
      } else {
        restOfQueryParams[key] = value;
      }
    }

    this._restOfQueryParams = restOfQueryParams;
  }

  async checkIfUserIsAlreadyConfirmed() {
    this.checkingIfUserIsAlreadyConfirmed = true;

    await this._authService.refreshJwt();

    const user = this._authService.getUserFromLocalToken();

    if (!user) {
      throw new Error();
    }

    if (!user.confirmed) {
      this._showAlert({
        text: tt('email_not_confirmed'),
        category: Category.DANGER,
      });

      this.checkingIfUserIsAlreadyConfirmed = false;

      return;
    }

    const nextUrl =
      location.search !== ''
        ? `../create-join-company${location.search}`
        : '../create-join-company';
    this._router.push(nextUrl);
  }

  @onDidMount()
  async onModuleInit() {
    const res = await this._authService.getUserFromMostRecentToken();

    if (res.error != null) {
      this._showAlert({
        text: ttErrors('generic'),
        category: Category.DANGER,
      });
    } else {
      this.userIsConfirmed = res.data.confirmed;
      this.userIsLoading = false;
    }
  }

  async confirmUser() {
    if (!this.token) {
      throw new Error();
    }

    const res = await this._authService.confirmUser(this.token);

    if (res === ConfirmUserResult.SUCCESS) {
      this._router.push(`../create-join-company?${queryString.stringify(this._restOfQueryParams)}`);
    } else {
      this.confirmationErrorOccurred = true;

      if (res === ConfirmUserResult.EMAIL_NOT_VERIFIED) {
        this._showAlert({
          text: ttErrors('email_not_verified'),
          category: Category.DANGER,
        });
      } else if (res === ConfirmUserResult.GENERIC_VALIDATION_ERROR) {
        this._showAlert({
          text: ttErrors('generic_validation_error'),
          category: Category.DANGER,
        });
      }
    }
  }
}
